import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { SectionContext } from "../context/sectionContext"
import { ConditionContext } from "../context/conditionContext"
import { ErrorContext } from "../context/errorContext"
import { JourneyContext } from "../context/journeyContext"
import { getValueFromJourney,getValueFromLookup } from "../services/helperFunctions"
import { lineCapital } from "../../shared/functions"

const PortfolioContainer = styled.div`
  display: flex;
  margin-bottom: 1rem;

  @media screen and (max-width: 980px) {
    flex-direction: column;
  }

  .left-addon input[type="checkbox"].css-checkbox:checked + label.css-label,
  input[type="radio"].css-checkbox:checked + label.css-label {
    background-position: 0 -54px;
  }

  @media (max-width: 767px){
    .left-addon input[type="checkbox"].css-checkbox ~ label.css-label {
      background-size: 27px;
    }
  }
`

const InputContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;
  margin-left: auto;
  @media screen and (max-width: 980px) {
    margin-left: 0;
  }

  & > .str-input {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  & input {
    border: none;
    outline: none;
    margin: 0;
    padding: 0;
    line-height: 4;
    height: 42px;
    background: ${props => props.channel === "A" ? "#ededed" :  "#fff"};
    background: var(--lumiq-bg);
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" ? "#ededed" :  "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    /* z-index: 999; */
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
    // min-height: 2rem;
  }
`

export default function ComponentFormPortfolioFields(props) {
  console.log({ props })
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [showLocalError, setShowLocalError] = useState(false)

  // const validate = target => {
  
  // }

  // const handleChange = ({ target }) => {

  // }

  return (
    <>
      <PortfolioContainer
        className={`form-group ${props.data.disabled ? "disable-input" : ""}`}
      >
        <div className={`checkbox-container `}>
          <div className="inner-addon left-addon">
            <div className="checkbox1">
              <input
                id={props.data.PortFolioFieldCheckbox.formControlKey}
                className={`css-checkbox form-control`}
                type="checkbox"
              />

              <label
                htmlFor={props.data.PortFolioFieldCheckbox.formControlKey}
                className="css-label"
              >
                <span style={{ display: "block" }}>
                  <span style={{ marginRight: "5px" }}>
                    {/* {props.data.PortFolioFieldCheckbox.label} */}
                    {lineCapital(getValueFromLookup(
                      "label",
                      props.data.PortFolioFieldCheckbox.label
                    )) || props.data.PortFolioFieldCheckbox.label}
                  </span>
                  <span className="tooltip-col text-tool-tip-design existing-tool-tip">
                    <div className="tool">i</div>
                    <span className="tooltiptext4">
                      {props.data.PortFolioFieldCheckbox.info}
                    </span>
                  </span>
                </span>
                <span>
                  {props.data.PortFolioFieldCheckbox.description}{" "}
                  <sub style={{ bottom: "1px" }}>
                    {props.data.PortFolioFieldCheckbox.smallText}
                  </sub>{" "}
                </span>
              </label>
            </div>
          </div>
        </div>

        <InputContainer channel={props.channel}>
          <div className="form-control str-input">
            <input
              type="text"
              name={props.data.PortfolioFieldInput.name}
              required={props.data.PortfolioFieldInput.required}
              // placeholder={props.data.PortfolioFieldInput.placeholder}
              placeholder={lineCapital(getValueFromLookup(
                "placeholder",
                props.data.PortfolioFieldInput.placeholder
              )) || props.data.PortfolioFieldInput.placeholder}
              disabled={props.data.PortfolioFieldInput.disabled}
              id={
                props.data.PortfolioFieldInput.id
                  ? props.data.PortfolioFieldInput.id
                  : props.data.PortfolioFieldInput.label
              }
              // onChange={handleChange}
              value={
                sectionState.sectionData[
                  props.data.PortfolioFieldInput.formControlKey
                ]
                  ? sectionState.sectionData[
                      props.data.PortfolioFieldInput.formControlKey
                    ]
                  : ""
              }
              // onBlur={e => {validate(e.target)}
            />
          </div>
          <span className="input-error">
            {(props.showError || showLocalError) &&
              errorState[props.PortfolioFieldInput.formControlKey]}
          </span>
        </InputContainer>
      </PortfolioContainer>
    </>
  )
}
